/**
 * @fileoverview CSS module for styling title sections
 * Used for rendering title sections with optional icon and text content
 *
 * @example
 * // Usage in component:
 * import styles from './Title.module.css';
 *
 * <div className={styles.container}>
 *   <h2 className={styles.title}>Title</h2>
 * </div>
 */

.flexible {
    min-height: 128px;
}

.title {
    font-family: 'Inter';
    font-style: normal;
    font-size: 24px;
    line-height: 32px;
    letter-spacing: -0.019em;
    color: var(--neutural900);
    font-weight: 500;
    padding: 0;
    margin: 0;
}

.title_container {
    display: flex;
    gap: 12px;
}

.accent {
    font-family: 'Gelica W01 SemiBold';
    letter-spacing: normal;
    font-size: 32px;
    line-height: 36px;
}

@media only screen and (min-width: 768px) {
    .flexible {
        min-height: 64px;
    }
}
